/* Storenta · Panier : ajout sans quitter la page + ouverture du panier latéral. */
(function () {
  if (window.StPanier) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function amount(c) { return (c / 100).toFixed(2); }
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId; if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }
  function drawer() { return document.getElementById('cart-drawer'); }
  function hasDrawer() { return !!document.querySelector('cart-drawer-component'); }
  function toCart(c) {
    var cur = c.currency;
    return {
      id: c.token, totalQuantity: c.item_count,
      cost: { totalAmount: { amount: amount(c.total_price), currencyCode: cur } },
      lines: c.items.map(function (i) { return { id: i.key, quantity: i.quantity, cost: { totalAmount: { amount: amount(i.final_line_price), currencyCode: cur } } }; }),
      discountCodes: (c.cart_level_discount_applications || []).filter(function (d) { return d.type === 'discount_code'; }).map(function (d) { return { applicable: true, code: d.title }; })
    };
  }
  function open() {
    var d = drawer();
    if (d && typeof d.open === 'function' && !d.isOpen) d.open();
  }
  function add(items, context) {
    var ids = sectionIds(), body = { items: items };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    var p = fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { return { cart: toCart(c), detail: { sections: res.sections || undefined, itemCount: c.item_count } }; });
      });
    var ev = new Event('shopify:cart:lines-update', { bubbles: true });
    ev.action = 'add';
    ev.context = context || 'product';
    ev.lines = items.map(function (i) { return { merchandiseId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.quantity || 1 }; });
    ev.promise = p;
    document.dispatchEvent(ev);
    return p.then(function (r) {
      var cd = document.querySelector('cart-drawer-component');
      if (cd && context === 'product' && cd.hasAttribute('auto-open')) setTimeout(open, 60);
      return r;
    });
  }
  window.StPanier = { add: add, open: open, hasDrawer: hasDrawer };

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-stp-add]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('.stp-up'), err = box && box.querySelector('[data-stp-err]');
    if (err) err.hidden = true;
    b.disabled = true;
    add([{ id: +b.dataset.stpAdd, quantity: 1 }], 'cart').catch(function (x) {
      b.disabled = false;
      if (err) { err.textContent = (x && (x.description || x.message)) || 'Ajout impossible, réessayez.'; err.hidden = false; }
    });
  });
})();
